import { formatUnits, parseUnits } from 'ethers';

export const fmt = (bn, decimals = 18, digits = 4) => {
  if (bn === undefined || bn === null) return '0';
  try {
    const s = formatUnits(bn.toString(), decimals);
    const n = parseFloat(s);
    if (isNaN(n)) return '0';
    if (n === 0) return '0';
    if (n < 0.0001) return '<0.0001';
    if (n < 1) return n.toFixed(digits);
    if (n < 1000) return n.toFixed(Math.min(digits, 2));
    if (n < 1_000_000) return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
    if (n < 1_000_000_000) return (n / 1_000_000).toFixed(2) + 'M';
    return (n / 1_000_000_000).toFixed(2) + 'B';
  } catch {
    return '0';
  }
};

export const fmtUSD = (bn, digits = 2) => '$' + fmt(bn, 18, digits);
export const fmtGRX = (bn, digits = 4) => fmt(bn, 18, digits) + ' GRX';

export const parseUSD = (str) => {
  try { return parseUnits(String(str || '0'), 18); } catch { return 0n; }
};
export const parseGRX = (str) => {
  try { return parseUnits(String(str || '0'), 18); } catch { return 0n; }
};

// Round a wei-scale bigint DOWN to `decimals` significant fractional digits.
// Ensures the value fits cleanly as a display number and prevents wei-level
// drift when the same amount is passed to multiple external calls.
export const roundWei = (weiBn, decimals = 4, tokenDecimals = 18) => {
  const b = BigInt(weiBn || 0n);
  if (b === 0n) return 0n;
  if (decimals >= tokenDecimals) return b;
  const step = 10n ** BigInt(tokenDecimals - decimals);
  return (b / step) * step;
};

export const truncateAddress = (a) => {
  if (!a) return '';
  return a.slice(0, 6) + '...' + a.slice(-4);
};

export const bpsToPct = (bps, digits = 2) => {
  if (bps === undefined || bps === null) return '0%';
  const n = Number(bps) / 100;
  return n.toFixed(digits) + '%';
};

export const secondsToDHMS = (s) => {
  s = Number(s || 0);
  if (s <= 0) return '0s';
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const parts = [];
  if (d) parts.push(d + 'd');
  if (h) parts.push(h + 'h');
  if (m) parts.push(m + 'm');
  if (!d && !h) parts.push(sec + 's');
  return parts.join(' ');
};

export const tsToDate = (ts) => {
  const n = Number(ts || 0);
  if (n === 0) return '—';
  return new Date(n * 1000).toLocaleString();
};

export const shortNumber = (n) => {
  const num = Number(n || 0);
  if (num < 1000) return String(num);
  if (num < 1_000_000) return (num / 1000).toFixed(1) + 'K';
  if (num < 1_000_000_000) return (num / 1_000_000).toFixed(1) + 'M';
  return (num / 1_000_000_000).toFixed(1) + 'B';
};
